<template>
  <div id="car">
    <van-tabs color="#887BFF" v-model="active" @click="car_type">
      <van-tab :title="$t('column.shop')" name="shop">
        <van-row class="car_shop">
          <van-col span="12" v-for="(l) in list" :key="l.id" class="car_type">
            <van-col span="24" class="car_div">
              <van-col span="24" class="car_img avatar_frame_div">
                <van-image :src="head_image" class="avatar_frame_img" round />
                <div :id='"svga"+l.id' class="avatar_frame_svga"></div>
              </van-col>
              <van-col span="24" class="car_name">{{ l.name }}</van-col>
              <van-col span="24" class="car_sum">{{ l.coin }}{{ diamonds_name }}/{{ l.day }} {{ $t('other.days') }}</van-col>
              <van-col span="20" offset="2" class="car_btn" @click="pay_btn(l.id)">{{ $t('btn.purchase')}}</van-col>
            </van-col>
          </van-col>
        </van-row>
      </van-tab>
      <van-tab :title="$t('column.myavatar')" name="my_avatar_frame">
        <van-row class="car_shop">
          <van-col span="12" v-for="(l) in user_list" :key="l.id" class="car_type">
            <van-col span="24" class="car_div">
              <van-col span="24" class="avatar_frame_name">{{ l.name }}</van-col>
              <van-col span="24" class="car_img my_car_img avatar_frame_div">
                <van-image :src="head_image" class="avatar_frame_img"/>
                <div :id='"mysvga"+l.id' class="avatar_frame_svga"></div>
              </van-col>
              <van-col span="24" class="my_car_sum">{{ $t('column.due_date') }}：</van-col>
              <van-col span="24" class="my_car_sum">{{ l.end_time }}</van-col>
              <van-col span="20" offset="2" class="car_btn" @click="open_btn(l.id)">
                {{ avatar_frame_id === l.avatar_id ? $t('other.close') : $t('other.open') }}
              </van-col>
            </van-col>
          </van-col>
        </van-row>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import {Dialog} from 'vant'
import SVGA from "svgaplayerweb"
export default {
  data() {
    return {
      active: 0,
      list: [],
      user_list: [],
      avatar_frame_id: '',
      user: [],
      diamonds_name: '',
      head_image: ''
    }
  },
  created: function () {
    this.convert();
    document.title = this.$t('title.shop')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    SVGA() {
      this.$nextTick(()=>{

        this.list.map((v,i)=>{
          //这里动态给ID，列表
          var player = new SVGA.Player('#svga'+v.id);
          var parser = new SVGA.Parser('#svga'+v.id);
          //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
          parser.load(v.img, function(videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          })
        })
      })
    },
    MYSVGA() {
      this.$nextTick(()=>{

        this.user_list.map((v,i)=>{
          //这里动态给ID，列表
          var player = new SVGA.Player('#mysvga'+v.id);
          var parser = new SVGA.Parser('#mysvga'+v.id);
          //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
          parser.load(v.img, function(videoItem) {
            player.setVideoItem(videoItem);
            player.startAnimation();
          })
        })
      })
    },
    convert: function () {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=avatar_frame&act=index", {
        params: {
          uid: uid,
          token: token
        }
      }).then(res => {
        console.log(res.data)
        this.head_image = res.data.data.head_image
        this.list = res.data.data.list
        this.diamonds_name = res.data.data.diamonds_name
        this.SVGA()
      })
    },
    car_type(name, title) {
      if (name === 'shop') {
        this.convert()
      } else {
        this.my_avatar_frame()
      }
    },
    my_avatar_frame: function () {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=avatar_frame&act=my_avatar_frame", {
        params: {
          uid: uid,
          token: token
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        } else {
          this.head_image = res.data.data.head_image
          this.user_list = res.data.data.my_avatar
          this.avatar_frame_id = res.data.data.select_id
          this.MYSVGA()
        }
      })
    },
    pay_btn(id) {
      Dialog.confirm({
        title: this.$t('column.avatar_frame'),
        message: this.$t('column.is_buy_avatar_frames'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=avatar_frame&act=pay", {
          params: {
            uid: uid,
            token: token,
            id: id
          }
        }).then(res => {
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.convert()
          }
        })

      })
    },
    open_btn(id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=avatar_frame&act=open_close", {
        params: {
          uid: uid,
          token: token,
          id: id
        }
      }).then(res => {
        Toast(res.data.error)
        if (res.data.status === 1) {
          this.my_avatar_frame()
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/avatar_frame.vue